import { addWeeks, addDays } from 'date-fns';

export const STANDARD = 'standard';
const DHL_EXPRESS = 'dhl_express';

export const AVAILABLE_DELIVERY_METHODS = [
  {
    key: STANDARD,
    title: 'cardorder.deliveryMethod.standard',
    estimateDeliveryDay: 'cardorder.deliveryMethod.estimateDeliveryDay',
    pricing: 'standardDeliveryPricing',
    deliveryDelayRange: [
      addWeeks(new Date(), 3).getTime(),
      addWeeks(new Date(), 4).getTime(),
    ],
  },
  {
    key: DHL_EXPRESS,
    title: 'cardorder.deliveryMethod.dhl',
    estimateDeliveryDay: 'cardorder.deliveryMethod.estimateDeliveryDay',
    pricing: 'expressDeliveryPricing',
    deliveryDelayRange: [
      addDays(new Date(), 4).getTime(),
      addDays(new Date(), 7).getTime(),
    ],
    flashMessage: 'cardorder.deliveryMethod.dhlFlashMessage',
  },
];

export const US_STATES_OPTIONS = [
  {
    key: 'AL',
    label: 'AL - Alabama',
  },
  {
    key: 'AK',
    label: 'AK - Alaska',
  },
  {
    key: 'AS',
    label: 'AS - American Samoa',
  },
  {
    key: 'AZ',
    label: 'AZ - Arizona',
  },
  {
    key: 'AR',
    label: 'AR - Arkansas',
  },
  {
    key: 'CA',
    label: 'CA - California',
  },
  {
    key: 'CO',
    label: 'CO - Colorado',
  },
  {
    key: 'CT',
    label: 'CT - Connecticut',
  },
  {
    key: 'DE',
    label: 'DE - Delaware',
  },
  {
    key: 'DC',
    label: 'DC - District of Columbia',
  },
  {
    key: 'FM',
    label: 'FM - Federated Stated of Micronesia',
  },
  {
    key: 'FL',
    label: 'FL - Florida',
  },
  {
    key: 'GA',
    label: 'GA - Georgia',
  },
  {
    key: 'GU',
    label: 'GU - Guam',
  },
  {
    key: 'HI',
    label: 'HI - Hawaii',
  },
  {
    key: 'ID',
    label: 'ID - Idaho',
  },
  {
    key: 'IL',
    label: 'IL - Illinois',
  },
  {
    key: 'IN',
    label: 'IN - Indiana',
  },
  {
    key: 'IA',
    label: 'IA - Iowa',
  },
  {
    key: 'KS',
    label: 'KS - Kansas',
  },
  {
    key: 'KY',
    label: 'KY - Kentucky',
  },
  {
    key: 'LA',
    label: 'LA - Louisiana',
  },
  {
    key: 'ME',
    label: 'ME - Maine',
  },
  {
    key: 'MH',
    label: 'MH - Marshall Islands',
  },
  {
    key: 'MD',
    label: 'MD - Maryland',
  },
  {
    key: 'MA',
    label: 'MA - Massachusetts',
  },
  {
    key: 'MI',
    label: 'MI - Michigan',
  },
  {
    key: 'MN',
    label: 'MN - Minnesota',
  },
  {
    key: 'MS',
    label: 'MS - Mississippi',
  },
  {
    key: 'MO',
    label: 'MO - Missouri',
  },
  {
    key: 'MT',
    label: 'MT - Montana',
  },
  {
    key: 'NE',
    label: 'NE - Nebraska',
  },
  {
    key: 'NV',
    label: 'NV - Nevada',
  },
  {
    key: 'NH',
    label: 'NH - New Hampshire',
  },
  {
    key: 'NJ',
    label: 'NJ - New Jersey',
  },
  {
    key: 'NM',
    label: 'NM - New Mexico',
  },
  {
    key: 'NY',
    label: 'NY - New York',
  },
  {
    key: 'NC',
    label: 'NC - North Carolina',
  },
  {
    key: 'ND',
    label: 'ND - North Dakota',
  },
  {
    key: 'MP',
    label: 'MP - Northern Mariana Islands',
  },
  {
    key: 'OH',
    label: 'OH - Ohio',
  },
  {
    key: 'OK',
    label: 'OK - Oklahoma',
  },
  {
    key: 'OR',
    label: 'OR - Oregon',
  },
  {
    key: 'PW',
    label: 'PW - Palau',
  },
  {
    key: 'PA',
    label: 'PA - Pennsylvania',
  },
  {
    key: 'PR',
    label: 'PR - Puerto Rico',
  },
  {
    key: 'RI',
    label: 'RI - Rhode Island',
  },
  {
    key: 'SC',
    label: 'SC - South Carolina',
  },
  {
    key: 'SD',
    label: 'SD - South Dakota',
  },
  {
    key: 'TN',
    label: 'TN - Tennessee',
  },
  {
    key: 'TX',
    label: 'TX - Texas',
  },
  {
    key: 'UT',
    label: 'UT - Utah',
  },
  {
    key: 'VT',
    label: 'VT - Vermont',
  },
  {
    key: 'VI',
    label: 'VI - Virgin Islands',
  },
  {
    key: 'VA',
    label: 'VA - Virginia',
  },
  {
    key: 'WA',
    label: 'WA - Washington',
  },
  {
    key: 'WV',
    label: 'WV - West Virginia',
  },
  {
    key: 'WI',
    label: 'WI - Wisconsin',
  },
  {
    key: 'WY',
    label: 'WY - Wyoming',
  },
];
